<template>
	<div>
		<div class="ModalPrompt">
			<h1>Invite a new user to {{ org.name }}</h1>
		</div>
		<div class="ModalBody">
            <SimpleForm
                :onSubmit="onSubmit"
                :fields="[
                    {
                        label : 'First name',
                        name : 'first_name',
                        autofocus : true,
                        required : true,
                    },
                    {
                        label : 'Last name',
                        name : 'last_name',
                        required : true,
                    },
                    {
                        label : 'Email address',
                        name : 'email',
                        type : 'email',
                        required : true,
                    },
                    {
                        name : 'org_id',
                        type : 'hidden',
                    },
                ]"
                :model="{ org_id : org.id }"
            />
		</div>
	</div>
</template>

<script>

	export default {
		props : ['invite','invites','org'],
		methods: {

			onSubmit : function(payload){
                var self = this;
				return api.call('post','/invites',payload)
						.then(({data})=>{
                            self.invites.push(data); 
                            Event.$emit('modal-close');
						})
			}

		}
	}
</script>